import React from 'react';

export type WithRenderCallbackProps = React.PropsWithChildren<{
    callback: () => void;
}>;

export const WithRenderCallback: React.FC<WithRenderCallbackProps> = ({children, callback}) => {
    React.useEffect(callback, [callback]);

    return <React.Fragment>{children}</React.Fragment>;
};
